import type { RuleHandler } from "../types";

const checkBaseRequirementType: RuleHandler = (context) => {
  const isSEM = context.selection.subOutcomesCount > 0;
  const requirements = (context.automation.requirements || []).find(
    (requirement) =>
      ["NON_SEM_BET_STAKE", "SEM_BET_STAKE"].includes(requirement.type),
  );

  if (!requirements) {
    return false;
  }

  if (isSEM && !requirements.type?.startsWith("SEM")) {
    return false;
  }

  if (!isSEM && !requirements.type?.startsWith("NON_SEM")) {
    return false;
  }

  return true;
};

export { checkBaseRequirementType };
